module.exports = __webpack_public_path__ + "static/coolinarycafe-logo-white-c78c796bceec0f44e0f87cf270e9af19.png";